import { createAction, props } from '@ngrx/store';
import type { FilterEntityType } from '../models';

export const setPageEntity = createAction(
	'[FILTER] Set page entity',
	props<{ entity: FilterEntityType | undefined }>()
);

export const clearPageEntity = createAction('[FILTER] Clear page entity');
